import { createFileRoute } from '@tanstack/react-router';

interface ProfileReviewsSearch {
  account?: string;
}

export const Route = createFileRoute('/admin/profile-reviews')({
  validateSearch: (search: Record<string, unknown>): ProfileReviewsSearch => ({
    account: typeof search.account === 'string' ? search.account : undefined,
  }),
});
